var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "fx-button",
      class: {
        "kind--default": _vm.kind === "default",
        "kind--link": _vm.kind === "link",
        "kind--icon": _vm.kind === "icon",
        "variant--default": _vm.variant === "default",
        "variant--primary": _vm.variant === "primary",
        "variant--accent": _vm.variant === "accent",
        "variant--square": _vm.variant === "square",
        "variant--frameless": _vm.variant === "frameless",
        "variant--knockout": _vm.variant === "knockout",
        "variant--fab": _vm.variant === "fab",
        "size--small": _vm.size === "small",
        "size--medium": _vm.size === "medium",
        "size--large": _vm.size === "large",
        loading: _vm.loading,
        active: _vm.active
      },
      attrs: {
        "aria-label": _vm.ariaLabel,
        type: _vm.type,
        disabled: _vm.disabled
      },
      on: {
        click: function($event) {
          _vm.$emit("click")
        }
      }
    },
    [
      _vm.loading && (_vm.type === "default" || _vm.kind === "link")
        ? _c("span", [
            _vm._v("\n        " + _vm._s(_vm.loadingCopy) + "\n    ")
          ])
        : _c("span", { staticClass: "fx-button-content" }, [
            _vm.icon
              ? _c("span", {
                  staticClass: "fx-button-icon",
                  class: "icon-" + _vm.icon
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.kind === "default" || _vm.kind === "link"
              ? _c(
                  "span",
                  { staticClass: "fx-button-label" },
                  [_vm._t("default", [_vm._v("Button")])],
                  2
                )
              : _vm._e()
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }